<div fxLayout="column">

<!--  <div fxLayout="row" style="margin-top:10px; font-size: 18px;">-->
<!--    Σύνθετη Αναζήτηση-->
<!--  </div>-->
  <div fxFlex="grow" fxLayout="row" fxLayoutAlign="center center" style="height: 50px; margin-bottom: 10px;">
    <span class="pageTitle" fxFlex="95">Σύνθετη αναζήτηση</span>
    <span><mat-icon (click)="close()">close</mat-icon></span>
  </div>

  <div fxLayout="row" style="margin-top: 20px;" fxLayoutGap="20px">
    <div fxLayout="column" fxFlex="70">

      <div fxLayout="row" style="height:50px;" fxLayoutAlign="space-evenly">
        <mat-form-field fxFlex="30">
          <mat-label>Κριτήριο αναζήτησης</mat-label>
          <mat-select [(ngModel)]="selectedField" (selectionChange)="searchCriteriaChanged()">
            <mat-option *ngFor="let field of fields" [value]="field">{{field.label}}</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field fxFlex="30">
          <mat-label>Τύπος αναζήτησης</mat-label>
          <mat-select [(ngModel)]="selectedQueryType" [disabled]="mustDisable">
            <mat-option *ngFor="let type of textSearchTypes" [value]="type">{{type.label}}</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field fxFlex="30" *ngIf="selectedField && selectedField.type !== 'select'">
          <mat-label>Κείμενο αναζήτησης</mat-label>
          <label>
            <input matInput [(ngModel)]="selectedQueryValue"/>
          </label>
        </mat-form-field>

        <mat-form-field fxFlex="30" *ngIf="selectedField && selectedField.type === 'select'">
            <mat-label>{{selectedField.label}}</mat-label>
            <mat-select [(ngModel)]="selectedField.value">
              <mat-option *ngFor="let item of getSelectedValueOptions()"
                          [value]="item">{{displayOptionValue(item)}}</mat-option>
            </mat-select>
        </mat-form-field>

        <button fxFlexAlign="center" style="background-color: transparent; border: 1px solid lightgray;" mat-icon-button (click)="formQuery()"> <mat-icon class="addIcon" fxFlexAlign="center" >add</mat-icon></button>

      </div>

      <div style="margin-top:20px; height:400px; overflow-y: auto">
        <div *ngFor="let searchCriteria of criteria let i = index" fxLayout="row" fxLayoutAlign="space-evenly">

          <div *ngIf="i === 0" fxFlex="10">&nbsp;</div>

          <div *ngIf="i > 0" fxFlex="10" fxLayout="column" fxLayoutGap="5px">
            <button [class.activeJunction]="searchCriteria.junction === 'AND'" *ngIf="i > 0" mat-raised-button style="width:50px; height:25px;"
                    (click)="alterJunction(searchCriteria, 0)">ΚΑΙ
            </button>
            <button [class.activeJunction]="searchCriteria.junction === 'OR'" *ngIf="i > 0" mat-raised-button style="width:50px; height:25px;"
                    (click)="alterJunction(searchCriteria, 1)">Ή
            </button>
          </div>

          <mat-form-field fxFlex="25">
            <mat-label>Κριτήριο αναζήτησης</mat-label>
            <mat-select [disabled]="searchCriteria.selectedField.type ==='select'" [(ngModel)]="searchCriteria.selectedField" (selectionChange)="reFormQuery()">
              <mat-option *ngFor="let field of fields" [value]="field">{{field.label}}</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field fxFlex="25">
            <mat-label>Τύπος αναζήτησης</mat-label>
            <mat-select [disabled]="searchCriteria.selectedField.type ==='select'" [(ngModel)]="searchCriteria.selectedQueryType" (selectionChange)="reFormQuery()">
              <mat-option *ngFor="let type of textSearchTypes" [value]="type">{{type.label}}</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field fxFlex="25">
            <mat-label>Κείμενο αναζήτησης</mat-label>
            <label>
              <input [readonly]="searchCriteria.selectedField.type ==='select'" matInput [(ngModel)]="searchCriteria.selectedQueryValue" (focusout)="reFormQuery()"/>
            </label>
          </mat-form-field>

          <mat-icon fxFlexAlign="center" matTooltip='Διαγραφή κριτηρίου' (click)="deleteCriteria(searchCriteria)">
            close
          </mat-icon>
        </div>
      </div>


    </div>

    <div fxLayout="column" fxFlex="30" style="height:470px; width:100%; border:1px solid lightgray">
      <div fxLayout="row" style="height: 55px; border-bottom: 1px solid lightgray; font-weight: bold; font-size: 14px" fxLayoutAlign="center center center">Αποθηκευμένα κριτήρια</div>

      <div *ngIf="loadingStoredQueries" fxFlex="grow" fxLayoutAlign="center center center">
        <app-loading></app-loading>
      </div>

      <div *ngIf="!loadingStoredQueries" style="height:400px; overflow-y: auto;">
        <div fxLayout="row"  class="storedQueries" fxLayoutAlign="start center center" *ngFor="let storedQuery of storedQueries" >
          <div fxFlex="90" (click)="renderSelectedQuery(storedQuery)" style="cursor: pointer" [matTooltip]="storedQuery.clause">
          {{storedQuery.title}}
          </div>
<!--          <div fxLayoutGap="5px">-->
            <mat-icon matTooltip="Ενημέρωση κριτηρίου" (click)="updateStoredCriteria(storedQuery)">update</mat-icon>
            <mat-icon style="color: red;" matTooltip="Διαγραφή κριτηρίου" (click)="deleteStoredCriteria(storedQuery)">delete</mat-icon>
<!--          </div>-->
        </div>
      </div>
    </div>
  </div>

  <div fxLayout="row" style="margin-top:20px; height: 100px;" fxLayoutGap="20px">
    <div fxLayout="column" fxFlex="80" style="border: 1px solid lightgray;">
      <div fxLayout="row" fxFlex="grow" fxLayoutGap="5px">
        <div style="opacity: 0.5; width:85%;">
          {{displayQuery}}
        </div>

        <div fxFlexAlign="flex-end">
          <button style="color: white; background-color: var(--secondaryBlue);" mat-raised-button (click)="storeQuery()">Αποθήκευση</button>
        </div>
      </div>
    </div>

    <div fxLayout="column" fxFlex="30" fxLayoutGap="5px" fxLayoutAlign="end">
      <button mat-raised-button (click)="close()">Ακύρωση</button>
            <button mat-raised-button style="background-color: var(--primary); color: white;" (click)="search()">Αναζήτηση</button>
    </div>

  </div>

</div>
